import { render, staticRenderFns } from "./UserForbid.vue?vue&type=template&id=64c3a3c9&"
import script from "./UserForbid.vue?vue&type=script&lang=js&"
export * from "./UserForbid.vue?vue&type=script&lang=js&"
import style0 from "./UserForbid.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports